import Highcharts from 'highcharts';

export const figure1 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      marginLeft: 180,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '1000px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },

    colors: ['#ff0000', '#ffd2d2'],

    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },

    plotOptions: {
      series: {
        borderWidth: 0,
        marker: {
          symbol: 'circle',
          enabled: false,
          states: {
            hover: {
              enabled: true,
              radius: 5
            }
          }
        }
      }
    },

    exporting: {
      enabled: false
    },

    xAxis: [{
      categories: [
		   'ملاوي 2015',
		   'نيجيريا 2013',
		   'نيجيريا 2018',
		   'بوروندي 2016',
		   'أوغندا 2014',
		   'توغو 2018',
		   'باكستان 2018',
		   'الكاميرون 2018',
		   'زامبيا 2018',
		   'النيجر 2018',
		   'جنوب أفريقيا 2016',
		   'غينيا 2018',
		   'بنين 2018',
		   '‫كوت ديفوار 2018',
		   'زيمبابوي 2015',
		   'غينيا بيساو 2018',
		   'بوركينا فاسو 2018',
		   'جمهورية تنزانيا المتحدة 2013',
		   'مالي 2018',
		   'إثيوبيا 2016',
		   'ألبانيا 2018',
		   'السنغال 2018',
		   'أرمينيا 2016',
		   'إندونيسيا 2017',
		   'موزمبيق 2011',
		   'ليسوتو 2013',
		   'منغوليا 2012',
		   'رواندا 2015',
		   'بلجيكا 2011',
		   'نيوزيلندا 2013',
		   'السويد 2011',
		   'جمهورية كوريا 2016',
		   'مملكة هولندا 2011',
		   'كوستاريكا 2011',
      ],
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      tickLength: 16,
      labels: {
        style: {
          fontWeight: 'normal',
          color: '#999999',
	  fontSize: '12px',
	  textOverflow: 'none',
        }
      },
    }],
    yAxis: [{
      labels: {
        format: '{value}',
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      max: 100,
      min: 0,
      tickInterval: 10,
      gridLineWidth: 0,
      title: {
        text: null,
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      }
    }],
    tooltip: {
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      style: {
        padding: 0
      }
    },
    legend: {
      enabled: false,
    },

    series: [{
    name: 'أنثى',
      tooltip: {
        valuePrefix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [
	     22.6,
	     16.2,
	     3.4,
	     3.6,
	     52.5,
	     29.2,
	     1.5,
	     2.7,
	     3.9,
	     1.8,
	     10.6,
	     6.6,
	     10,
	     9,
	     8.2,
	     21.2,
	     13.2,
	     33.9,
	     11.4,
	     18,
	     21.9,
	     22.4,
	     29.7,
	     12,
	     11.2,
	     null,
	     26.8,
	     86.4,
	     54.3,
	     null,
	     30.2,
	     null,
	     64,
	     null,
      ]
    },{
        name: 'مجموع السكان',
      tooltip: {
        valuePrefix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [

	     1.9,
	     2.1,
	     7.7,
	     7.8,
	     8,
	     9.2,
	     9.8,
	     9.8,
	     10.3,
	     12.8,
	     15.8,
	     16.5,
	     17.1,
	     17.9,
	     21.4,
	     21.7,
	     24.6,
	     25,
	     26.9,
	     32.2,
	     36.4,
	     39.9,
	     41.9,
	     45.8,
	     49.8,
	     61.1,
	     65.4,
	     85.8,
	     94.8,
	     99,
	     99.3,
	     100,
	     100,
	     100,
	     
      ],
    }]
}
